(() => {
  const formLocks = new WeakSet();

  function cartInputs(form) {
    return [...form.querySelectorAll('[data-cart-quantity]')];
  }

  function syncCart(form) {
    const inputs = cartInputs(form);
    const totals = new Map();
    inputs.forEach(input => {
      input.setCustomValidity('');
      const quantity = Number(input.value);
      if (Number.isInteger(quantity) && quantity >= 0) {
        totals.set(input.dataset.variantId, (totals.get(input.dataset.variantId) || 0) + quantity);
      }
    });
    inputs.forEach(input => {
      const total = totals.get(input.dataset.variantId) || 0;
      const ruleMax = input.dataset.ruleMax;
      const inventoryMax = input.dataset.inventoryMax;
      if (ruleMax !== undefined && ruleMax !== '' && total > Number(ruleMax)) {
        input.setCustomValidity(`同じ商品の合計数量は ${ruleMax} 点までです。`);
      } else if (inventoryMax !== undefined && inventoryMax !== '' && total > Number(inventoryMax)) {
        input.setCustomValidity(`在庫を超える数量です。同じ商品の合計を ${inventoryMax} 点以下に変更してください。`);
      }
    });
    const dirty = inputs.some(input => input.value !== input.defaultValue);
    const status = form.querySelector('[data-cart-changes]');
    if (status) status.hidden = !dirty;
    const checkout = form.querySelector('[name="checkout"]');
    if (checkout) {
      checkout.disabled = dirty;
      if (dirty) checkout.setAttribute('aria-describedby', 'CartChanges');
      else checkout.removeAttribute('aria-describedby');
    }
    if (status) status.id = 'CartChanges';
    return dirty;
  }

  function initializeCart() {
    const form = document.getElementById('CartForm');
    if (form) syncCart(form);
  }

  document.addEventListener('click', event => {
    const blockedButton = event.target.closest('button[aria-disabled="true"]');
    if (blockedButton) {
      event.preventDefault();
      return;
    }
    const button = event.target.closest('[data-quantity]');
    if (button) {
      const input = button.parentElement.querySelector('input');
      if (!input || input.disabled || input.readOnly || button.disabled) return;
      const min = input.min !== '' ? Number(input.min) : 1;
      if (input.value === '' || !Number.isFinite(Number(input.value))) input.value = String(min);
      if (Number(button.dataset.quantity) < 0) input.stepDown();
      else input.stepUp();
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const link = event.target.closest('[data-gallery-image]');
    if (link) {
      const gallery = link.closest('.product-gallery');
      const image = gallery?.querySelector('.main-image img');
      if (!image) return;
      event.preventDefault();
      image.src = link.dataset.galleryImage;
      image.removeAttribute('srcset');
      image.alt = link.querySelector('img')?.alt || '';
      gallery.querySelectorAll('[data-gallery-image]').forEach(item => item.removeAttribute('aria-current'));
      link.setAttribute('aria-current', 'true');
    }
  });

  document.addEventListener('input', event => {
    if (event.target.matches('[data-cart-quantity]')) syncCart(event.target.form);
  });

  document.addEventListener('change', event => {
    if (event.target.matches('[data-cart-quantity]')) syncCart(event.target.form);
    if (event.target.matches('[data-variant-select]')) event.target.form.requestSubmit();
  });

  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('.product-form, .variant-form, #CartForm') || event.defaultPrevented) return;
    if (formLocks.has(form) || form.dataset.variantPending === 'true') {
      event.preventDefault();
      return;
    }
    if (form.id === 'CartForm') {
      const dirty = syncCart(form);
      if (!form.reportValidity() || (dirty && event.submitter?.name === 'checkout')) {
        event.preventDefault();
        return;
      }
    }
    if (form.matches('.variant-form')) {
      const productForm = form.closest('.product-section')?.querySelector('.product-form');
      if (productForm) {
        productForm.dataset.variantPending = 'true';
        productForm.querySelectorAll('button[type="submit"]').forEach(button => {
          if (!button.disabled) {
            button.dataset.variantDisabled = 'true';
            button.disabled = true;
          }
        });
      }
      const status = form.querySelector('[data-variant-status]');
      if (status) status.textContent = '選択した商品の価格・在庫を確認しています。';
    }
    formLocks.add(form);
    form.setAttribute('aria-busy', 'true');
    // Keep successful controls enabled so the native POST retains quantity,
    // order note and the checkout submitter's name. Shopify owns the totals.
    form.querySelectorAll('button[type="submit"]').forEach(button => button.setAttribute('aria-disabled', 'true'));
  });

  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    document.querySelectorAll('.product-form, .variant-form, #CartForm').forEach(form => {
      formLocks.delete(form);
      form.removeAttribute('aria-busy');
      delete form.dataset.variantPending;
      form.querySelectorAll('button[type="submit"]').forEach(button => button.removeAttribute('aria-disabled'));
      form.querySelectorAll('[data-variant-disabled]').forEach(button => {
        button.disabled = false;
        delete button.dataset.variantDisabled;
      });
    });
    document.querySelectorAll('[data-variant-select]').forEach(select => {
      const originalOption = [...select.options].find(option => option.defaultSelected);
      if (originalOption) select.value = originalOption.value;
    });
    initializeCart();
  });

  initializeCart();
  document.addEventListener('shopify:section:load', initializeCart);
})();
